import styled from "styled-components";

export const StyledListsDropdown = styled.div`
    flex-grow: 1;
    flex-shrink: 1;
    min-width: 50px;
    position: relative;
    z-index: 111;
`;
